import call from "./call";
import {
  VoicesBufferChannels,
  VoicesCompanyPage,
  VoicesCompanyPagePayload,
  VoicesCompanyPagesResponse,
  VoicesPeopleResponse,
  VoicesPerson,
  VoicesPublishingSettings,
} from "../Models/voicesProfiles";
import { voicesHeaders } from "../Helpers/voicesWorkspace";

export const getOwnVoicesProfile = async (): Promise<VoicesPerson> => {
  const response = await call.get<VoicesPerson>("/v1/voices/profiles/me/", {
    headers: voicesHeaders(),
  });
  return response.data;
};

export const updateOwnVoicesProfile = async (
  preferences: string,
): Promise<VoicesPerson> => {
  const response = await call.put<VoicesPerson>(
    "/v1/voices/profiles/me/",
    { preferences },
    {
      headers: voicesHeaders(),
      snack: {
        success: "voices.profileUpdateSuccess",
        error: "voices.profileUpdateError",
      },
    },
  );
  return response.data;
};

export const getVoicesPeople = async (): Promise<VoicesPerson[]> => {
  const response = await call.get<VoicesPeopleResponse>(
    "/v1/voices/profiles/people/",
    { headers: voicesHeaders(), snack: { error: "voices.peopleFetchError" } },
  );
  return response.data.people;
};

export const updateVoicesPerson = async (
  personId: number,
  data: VoicesPublishingSettings,
): Promise<VoicesPerson> => {
  const response = await call.put<VoicesPerson>(
    `/v1/voices/profiles/people/${personId}/`,
    data,
    {
      headers: voicesHeaders(),
      snack: {
        success: "voices.personUpdateSuccess",
        error: "voices.personUpdateError",
      },
    },
  );
  return response.data;
};

export const getVoicesCompanyPages = async (): Promise<VoicesCompanyPage[]> => {
  const response = await call.get<VoicesCompanyPagesResponse>(
    "/v1/voices/company_pages/",
    {
      headers: voicesHeaders(),
      snack: { error: "voices.companyPagesFetchError" },
    },
  );
  return response.data.company_pages;
};

export const createVoicesCompanyPage = async (
  data: VoicesCompanyPagePayload,
): Promise<VoicesCompanyPage> => {
  const response = await call.post<VoicesCompanyPage>(
    "/v1/voices/company_pages/",
    data,
    {
      headers: voicesHeaders(),
      snack: {
        success: "voices.companyPageCreateSuccess",
        error: "voices.companyPageCreateError",
      },
    },
  );
  return response.data;
};

export const updateVoicesCompanyPage = async (
  pageId: number,
  data: VoicesCompanyPagePayload,
): Promise<VoicesCompanyPage> => {
  const response = await call.put<VoicesCompanyPage>(
    `/v1/voices/company_pages/${pageId}/`,
    data,
    {
      headers: voicesHeaders(),
      snack: {
        success: "voices.companyPageUpdateSuccess",
        error: "voices.companyPageUpdateError",
      },
    },
  );
  return response.data;
};

export const deleteVoicesCompanyPage = async (pageId: number): Promise<void> => {
  await call.delete(`/v1/voices/company_pages/${pageId}/`, {
    headers: voicesHeaders(),
    snack: {
      success: "voices.companyPageDeleteSuccess",
      error: "voices.companyPageDeleteError",
    },
  });
};

export const getVoicesBufferChannels = async (
  refresh: boolean,
): Promise<VoicesBufferChannels> => {
  const response = await call.get<VoicesBufferChannels>(
    "/v1/voices/buffer/channels/",
    {
      headers: voicesHeaders(),
      params: { refresh: refresh ? 1 : undefined },
      snack: { error: "voices.bufferChannelsFetchError" },
    },
  );
  return response.data;
};
